import React from 'react';
import { motion, AnimatePresence } from 'motion/react';

interface SignOutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SignOutModal: React.FC<SignOutModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div key="sign-out-modal-wrapper" className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/75"
          />
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 15 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 15 }}
            className="relative w-full max-w-md bg-[#3a3430] border border-white/[0.06] rounded-xl overflow-hidden max-h-[calc(100vh-2rem)] md:max-h-[calc(100vh-4rem)] flex flex-col text-white"
          >
            {/* Header */}
            <div className="px-6 py-5 border-b border-white/[0.06] bg-[#322D29] shrink-0">
              <div className="flex items-center gap-3 mb-1.5">
                <div className="w-7 h-7 rounded bg-[#F26522] flex items-center justify-center text-white">
                  <i className="fas fa-power-off text-xs"></i>
                </div>
                <h2 className="text-sm font-bold uppercase tracking-widest text-white font-heading">
                  Sign Out?
                </h2>
              </div>
              <p className="text-[11px] font-medium text-white/60 tracking-wide">
                Confirming will sign you out of your account and end your active session.
              </p>
            </div>

            {/* Body */}
            <div className="p-6 flex-1 overflow-y-auto custom-scrollbar space-y-6">
              <p className="text-xs text-white/70 leading-relaxed font-dm">
                Are you sure you want to sign out? You will need to sign in again with your password to access your venture history and saved preferences.
              </p>

              <div className="grid grid-cols-2 gap-3 pt-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-3 border border-white/10 hover:bg-white/5 text-white/80 hover:text-white rounded-lg text-[10px] font-bold uppercase tracking-wider transition-colors cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                  className="px-4 py-3 bg-[#F26522] hover:bg-[#F26522]/90 text-white rounded-lg text-[10px] font-bold uppercase tracking-wider transition-colors cursor-pointer font-heading"
                >
                  Confirm Sign Out
                </button>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-3 bg-[#322D29] border-t border-white/[0.06] flex justify-center">
              <span className="text-[9px] font-bold uppercase tracking-[0.25em] text-white/40">
                Account Security
              </span>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default SignOutModal;
